import { Breakpoint } from "./breakpoints";

/**
 * Interface that extends built in MediaQueryList type, provides additional
 * identifying information such as breakpoint value and name
 */
export interface MediaQueryInfo extends MediaQueryList {
  size: number;
  breakpoint: Breakpoint;
  screenMode: ScreenMode;
}

export enum ScreenMode {
  MOBILE = 1,
  DESKTOP = 0,
}
